import { Image, View } from "@/components/ui";
import { DotOutline } from "@/components/shared/icons";
import { formatNumber, formatPrice } from "@/lib/helpers/number";
import { Typography } from "@/components/shared/typography";
import Cart from "@/assets/images/3d-icons/cart.png";
import { getServiceUnit } from "@/lib/booking-lib";
import type { ServiceName } from "@/types/service";
import { ServiceLuceGuarantee } from "./service-luce-guarantee";
import { ServicePayLater } from "./service-pay-later";

export function ServiceHeroSection({
  title,
  name,
  descriptions,
  bookingTotal,
  startPrice,
}: {
  title: string;
  name: ServiceName;
  descriptions: string[];
  bookingTotal: number;
  startPrice: number;
}) {
  return (
    <View className="flex w-full flex-1">
      <View className="mt-2 flex flex-1 flex-col gap-2 max-lg:mx-4">
        <View className="flex flex-row items-start">
          <View className="flex flex-1 flex-col gap-2">
            <View className="flex flex-row justify-between gap-2">
              <Typography variant="h3">{title}</Typography>
              <View className="flex flex-row items-center gap-1 web:hidden">
                <Typography color="foreground-intermediate" variant="body-sm">
                  Start
                </Typography>
                <Typography variant="h3" color="brand-primary">
                  {`${formatPrice(startPrice, 0)}/${getServiceUnit(name)}`}
                </Typography>
              </View>
            </View>
            <View className="flex flex-row justify-between gap-2 rounded-full bg-background-intermediate px-2 py-1 md:py-2">
              <View className="mx-auto flex cursor-pointer flex-row gap-1">
                <Image
                  src={Cart}
                  alt="Service Booking"
                  width={16}
                  height={16}
                />
                <Typography variant="caption-md">
                  Bookings {formatNumber(bookingTotal)}
                </Typography>
              </View>
              <Typography variant="caption-md" color="foreground-attenuated">
                •
              </Typography>
              <ServiceLuceGuarantee />
              <Typography variant="caption-md" color="foreground-attenuated">
                •
              </Typography>
              <ServicePayLater />
            </View>
          </View>
        </View>
        <View className="flex flex-col">
          {descriptions.map((desc) => (
            <View className="flex flex-row" key={desc}>
              <DotOutline
                size={18}
                weight="fill"
                className="text-foreground-intermediate"
              />
              <Typography
                variant="body-sm"
                color="foreground-intermediate"
                key={desc}
              >
                {desc}
              </Typography>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}
